import axios from 'axios'
import { THIRD_PARTY } from '../constants'
import { postToApiWithoutToken } from "./index";
import { LOCALSTORAGE_KEYS } from "../utils/constants";

const axiosClient = axios.create()
axiosClient.CancelToken = axios.CancelToken
axiosClient.isCancel = axios.isCancel

export const getAssociate = async (idType, idNumber, thirdPartyType) => {
   const token_app = await getTokenAsoc();
   const headers = { 'Content-Type': 'application/json' , 'Authorization': `Bearer ${token_app}`}
   const endpoint = `${process.env.REACT_APP_ASSOCIATE_API}${THIRD_PARTY}/${idType}/${idNumber}/${thirdPartyType}`
   const response = await axiosClient.get(endpoint, { headers })
   return response.data
}

export const deleteAssociate = async id => {
   const token_app =  await getTokenAsoc();
   const headers = { 'Content-Type': 'application/json' , 'Authorization': `Bearer ${token_app}`}
   const endpoint = `${process.env.REACT_APP_ASSOCIATE_API}${THIRD_PARTY}/${id}`
   const response = await axiosClient.delete(endpoint, { headers })
   return response.data
}

export const getTokenAsoc = async () => {
    const asoc_data = JSON.parse(process.env.REACT_APP_DATA_LOGIN_ASOC);
    const payload = {
        username: asoc_data[0],
        password: asoc_data[1]
    }
    const url = `${process.env.REACT_APP_LOGIN_API}/users/login`
    const data = await postToApiWithoutToken(url, payload)
    localStorage.setItem(LOCALSTORAGE_KEYS.TOKEN_APP, data.access_token)
    return data.access_token
}

export const getCollaborator = async(docType, docNumber, email) => {
    const token_app = await getTokenAsoc()
    const url = `${process.env.REACT_APP_ASSOCIATE_API}${THIRD_PARTY}/consultarColaborador/${docType}/${docNumber}/${email}`
    const headers = { 'Content-Type': 'application/json' , 'Authorization': `Bearer ${token_app}`}
    const { data } = await axiosClient.post(url, {}, { headers })
    return data
}

export const sendCollaboratorMail = async docNumber => {
    const url = `${process.env.REACT_APP_ASSOCIATE_API}${THIRD_PARTY}/resend/${docNumber}`
    const token_app = localStorage.getItem(LOCALSTORAGE_KEYS.TOKEN_APP);
    const headers = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token_app}` }
    const response = await axiosClient.post(url, {}, { headers })
    return response.data
}
